import { Message, MessageResponse } from '@/types/residents/message';
import dayjs from 'dayjs';

export const messages: Message[] = [
  {
    id: 'MSG001',
    type: 'announcement',
    status: 'delivered',
    priority: 'high',
    channel: 'all',
    subject: 'Community Maintenance Notice',
    content: 'Dear Residents, We will be conducting annual maintenance of the swimming pool from March 20-25. The pool will be closed during this period. We apologize for any inconvenience caused.',
    senderId: 'ADM001',
    senderName: 'Community Manager',
    senderRole: 'Administrator',
    recipients: [
      {
        id: 'RES001',
        name: 'John Doe',
        email: 'john.doe@email.com',
        phone: '+1-555-0124',
        status: 'read',
        readAt: dayjs('2024-03-15T11:30:00').toDate()
      },
      {
        id: 'RES002',
        name: 'Jane Smith',
        email: 'jane.smith@email.com',
        phone: '+1-555-0125',
        status: 'delivered'
      }
    ],
    attachments: [
      {
        id: 'ATT001',
        name: 'Maintenance Schedule',
        type: 'pdf',
        url: '/documents/messages/MSG001/schedule.pdf',
        uploadedAt: dayjs('2024-03-15').toDate()
      }
    ],
    scheduledFor: dayjs('2024-03-15T10:00:00').toDate(),
    expiresAt: dayjs('2024-03-25T23:59:59').toDate(),
    tags: ['maintenance', 'pool', 'announcement'],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    },
    activityRecords: []
  }
];

export const messageResponses: MessageResponse[] = [
  {
    ...messages[0],
    summary: {
      totalRecipients: 2,
      deliveredCount: 2,
      readCount: 1,
      failedCount: 0
    },
    history: [
      {
        id: 'HIS001',
        date: dayjs('2024-03-15').toDate(),
        status: 'sent',
        details: 'Message sent to all recipients',
        performedBy: 'SYS001'
      },
      {
        id: 'HIS002',
        date: dayjs('2024-03-15').toDate(),
        status: 'delivered',
        details: 'Message delivered to all recipients',
        performedBy: 'SYS001'
      }
    ],
    analytics: {
      openRate: 50,
      clickRate: 25,
      responseTime: 90, // minutes
      engagementScore: 75
    }
  }
]; 